import config from '@/i18n/config'

export default {
	'raw-cardamom': `${config['raw-cardamom'].es}`,
	material: 'Material',
}